import React from "react";
import { useWallet } from "@/context/WalletContext";
import { usePolling } from "@/components/croc/hooks";
import { Panel, Pill } from "@/components/croc/ui";
import api from "@/lib/api";
import { History, CheckCircle2, XCircle } from "lucide-react";

export const ResolvedPredictions = () => {
  const { address } = useWallet();
  const { data } = usePolling(() => api.predictionResolved(address || "0x0"), [address], 30000);
  const items = data?.items ?? [];

  return (
    <Panel className="mb-6" data-testid="resolved-predictions">
      <div className="flex items-center justify-between mb-4 flex-wrap gap-3">
        <div className="flex items-center gap-2">
          <History className="w-4 h-4 gold-text" />
          <span className="font-display font-bold text-white">Your Resolved Predictions</span>
        </div>
        {data && (
          <div className="flex items-center gap-2">
            <Pill tone="emerald" data-testid="resolved-wins">{data.wins} won</Pill>
            <Pill tone="danger" data-testid="resolved-losses">{data.losses} lost</Pill>
          </div>
        )}
      </div>

      {items.length === 0 ? (
        <div className="text-center py-8 text-muted-foreground text-sm" data-testid="resolved-empty">
          No settled predictions yet — answered questions appear here once the real Polymarket result lands.
        </div>
      ) : (
        <div className="space-y-2 max-h-[340px] overflow-y-auto pr-1">
          {items.map((r, i) => (
            <div key={`${r.day}-${r.slot}-${i}`} className="rounded-xl border border-white/10 bg-[#090E0B] p-3.5" data-testid={`resolved-row-${i}`}>
              <div className="flex items-start justify-between gap-3">
                <div className="min-w-0">
                  <div className="text-sm text-white leading-snug">{r.question}</div>
                  <div className="text-[10px] text-muted-foreground mt-1">
                    {r.day} · You picked <span className={r.side === "yes" ? "emerald-text" : "text-red-400"}>{(r.side || "").toUpperCase()}</span>
                    {" · "}Result <span className="text-white">{(r.winning_side || "").toUpperCase()}</span>
                  </div>
                </div>
                {r.correct ? (
                  <span className="shrink-0 inline-flex items-center gap-1 text-[11px] emerald-text" data-testid={`resolved-win-${i}`}>
                    <CheckCircle2 className="w-3.5 h-3.5" /> WON
                  </span>
                ) : (
                  <span className="shrink-0 inline-flex items-center gap-1 text-[11px] text-red-400" data-testid={`resolved-loss-${i}`}>
                    <XCircle className="w-3.5 h-3.5" /> LOST
                  </span>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </Panel>
  );
};
